import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAuthentications = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 21"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10 16.898a6.685 6.685 0 1 0 0-13.37 6.685 6.685 0 0 0 0 13.37m3.12-7.895a.75.75 0 1 0-1.06-1.06l-3.115 3.114-1.02-.961a.75.75 0 1 0-1.03 1.092l2.08 1.96z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAuthentications;
